import { lazy } from 'react';

export async function loader(args) {
  const load = await import('./loader');
  return load.default(args);
}

export const Layout = lazy(() => import('./layout'));
